import { faFileSpreadsheet } from '@fortawesome/pro-solid-svg-icons'
import { notification } from 'antd'
import { useState } from 'react'
import FabButton from '../common/FabButton'
import TimeCsvExporter from './TimeCsvExporter'
import { timesheetCsvReportUrl, timesheetSummaryCsvReportUrl, TimesheetsFilters } from './timesheetsModel'

type Props = {
  filters: TimesheetsFilters
}

type CsvExportRequest = {
  toggle: boolean
  timesheetReportUrl: string
  summaryReportUrl: string
  startingDate: string
  endingDate?: string
}

const TimesheetsCsvExportButton = ({ filters }: Props) => {
  const [exportRequest, setExportRequest] = useState<CsvExportRequest | null>(null)

  const handleExport = () => {
    const starting = filters.starting
    if (!starting) {
      notification.warning({
        message: 'Please select a starting date for the csv report.',
        description: 'You may also select an ending date, crew member, or search query and filter by submitted and exported entries.',
      })
      return
    }
    setExportRequest(previous => ({
      toggle: !(previous?.toggle ?? false),
      timesheetReportUrl: timesheetCsvReportUrl(filters),
      summaryReportUrl: timesheetSummaryCsvReportUrl(filters),
      startingDate: starting,
      endingDate: filters.ending,
    }))
  }

  return <>
    <FabButton icon={faFileSpreadsheet} title="Export to CSV" onClick={handleExport} />
    {exportRequest && <TimeCsvExporter
      handleExport={exportRequest.toggle}
      timesheetReportUrl={exportRequest.timesheetReportUrl}
      summaryReportUrl={exportRequest.summaryReportUrl}
      startingDate={exportRequest.startingDate}
      endingDate={exportRequest.endingDate}
    />}
  </>
}

export default TimesheetsCsvExportButton
